import { dateOnly, InferSubmit, object } from '@if/core/yup'
import { useMemo } from 'react'
import { previewedSimulation } from '../LoanCalendarActionPreview/LoanCalendarActionPreview-schema'

/** Activation-date and ledger rules are the backend's: their refusal surfaces through the preview error. */
export const getChargeOffSchema = () =>
  object({
    effectiveDate: dateOnly().default(null).required(),
    previewedSimulation: previewedSimulation(),
  })

export type ChargeOffSchemaType = InferSubmit<ReturnType<typeof getChargeOffSchema>>

export const useChargeOffSchema = () => useMemo(() => getChargeOffSchema(), [])
